import React from "react"
interface VideoIconProps {
  className?: string;
}
const VideoIcon :React.FC<VideoIconProps>= ({ className }) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="34" height="34" rx="5" fill="#0A1E46" />
      <path
        d="M20.1378 14.2267L16.2975 11.6038C16.1102 11.4728 15.9416 11.4165 15.7731 11.4165C15.3984 11.4165 15.136 11.7348 15.136 12.2221V17.7302C15.136 18.2171 15.3797 18.5358 15.7731 18.5358C15.9416 18.5358 16.129 18.4795 16.2975 18.3482L20.1378 15.7256C20.419 15.538 20.5688 15.2572 20.5688 14.976C20.5688 14.6952 20.419 14.414 20.1378 14.2267Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
      <mask
        id="mask0_26164_6678"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="8"
        width="26"
        height="18"
      >
        <path
          d="M5 8.55005H29V25.4112H5V8.55005Z"
          fill="white"
          stroke="white"
          strokeWidth="0.3"
        />
      </mask>
      <g mask="url(#mask0_26164_6678)">
        <path
          d="M7.23053 25.4112H26.7695C27.9873 25.4112 28.9802 24.4183 28.9802 23.2005V10.7607C28.9802 9.54297 27.9873 8.55005 26.7695 8.55005H7.23053C6.01275 8.55005 5.01984 9.54297 5.01984 10.7607V23.1818C5.01984 24.4183 6.01275 25.4112 7.23053 25.4112ZM27.1257 23.163H11.3516C11.2206 23.9127 10.6586 24.2685 9.98407 24.2685C9.30985 24.2685 8.74788 23.9127 8.61651 23.163H6.89307C6.68698 23.163 6.51842 22.9945 6.51842 22.7884C6.51842 22.5823 6.68698 22.4137 6.89307 22.4137H8.65404C8.84137 21.8517 9.36615 21.4583 9.98407 21.4583C10.6023 21.4583 11.1271 21.8517 11.3145 22.4137H27.1257C27.3318 22.4137 27.5004 22.5823 27.5004 22.7884C27.5004 22.9945 27.3318 23.163 27.1257 23.163ZM5.76913 10.8358C5.76913 10.0302 6.4437 9.29969 7.24894 9.29969H26.7882C27.5938 9.29969 28.2497 10.0302 28.2497 10.8358V20.5405H5.76913V10.8358Z"
          fill="white"
          stroke="white"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  )
}

export default VideoIcon
